export const gender = {
    1: 'male',
    2: 'female',
    3: 'other',
};

export const GENDER_MODEL = {
    MALE: {
        id: 1,
        name: 'male'
    },
    FEMALE: {
        id: 2,
        name: 'female'
    },
    OTHER: {
        id: 3,
        name: 'other'
    }
};

/**
 * Finds a gender object by its ID from the GENDER_MODEL.
 *
 * @param {number|string} id - The ID of the gender to search for.
 * @returns {{id: number, name: string} | undefined} The matching gender object, or undefined if not found.
 */
export const findGenderById = (id) => {
    return Object.values(GENDER_MODEL).find(item => item.id === id);
};
